import visitsFormatters from './gridFormatters';

export const visitsListHeaders = [
  { header: 'receivedOn', label: 'date received' },
  { header: 'agencyName', label: 'agency' },
  { header: 'partnerName', label: 'partner' },
  { header: 'originalReferenceNumber', label: 'reference' },
  { header: 'visitID', label: 'visit id' },
  { header: 'status', label: 'status' },
  { header: 'visitStatus', label: 'visit type', formatter: visitsFormatters.formatVisitStatus },
  { header: 'aggregatorID', label: 'node' },
  { header: 'payerID', label: 'payer' },
  { header: 'errorMessage', label: 'errors' },
];
